<template>
  <div class="boxes-card">
    <!-- 搜索框 -->
    <el-card shadow="never">
      <div class="search-bar">
        <el-input
          v-model="searchText"
          placeholder="请输入企业ID或企业名称"
          clearable
          style="width: 300px;"
          @keyup.enter.native="onSearch"
        >
          <template #append>
            <el-button type="primary" @click="onSearch">查询</el-button>
          </template>
        </el-input>
      </div>
    </el-card>

    <el-card class="box-card" shadow="never">
      <div slot="header" class="clearfix">
        <span>企业列表</span>
      </div>

      <!-- 加载中 -->
      <div v-if="loading" class="loading-wrapper">
        <el-spinner type="circle" /> 加载中…
      </div>

      <!-- 无数据 -->
      <div v-else-if="!corpListData.length" class="loading-wrapper">
        暂无数据
      </div>

      <!-- 有数据 -->
      <el-table
        v-else
        :data="corpListData"
        stripe
        border
        style="width: 100%;"
      >
        <!-- 企业名称 -->
        <el-table-column prop="corp_name" label="企业名称" align="center" />

        <!-- 企业 ID（点击复制） -->
        <el-table-column label="企业 ID" align="center">
          <template #default="{ row }">
            <span class="copy-text" @click="copyText(row.corp_id)">
              {{ row.corp_id }}
            </span>
          </template>
        </el-table-column>

        <!-- 应用 ID（弹窗修改） -->
        <el-table-column label="应用 ID" align="center">
          <template #default="{ row }">
            <span>{{ row.agent_id }}</span>
            <el-button
              type="text"
              icon="el-icon-edit"
              @click="openDialog(row)"
            />
          </template>
        </el-table-column>

        <!-- 是否开启转发源开关 -->
        <el-table-column label="是否开启转发源" align="center">
          <template #default="{ row }">
            <el-switch
              v-model="row.relaySourceBool"
              @change="onRelayChange(row)"
            />
          </template>
        </el-table-column>

        <!-- H5 链接（点击复制） -->
        <el-table-column label="H5 链接" align="center">
          <template #default="{ row }">
            <span class="copy-text" @click="copyText(row.h5_link)">
              戳我复制
            </span>
          </template>
        </el-table-column>

        <!-- 管理员名称 & 时间 -->
        <el-table-column prop="admin_name" label="管理员名称" align="center" />
        <el-table-column prop="created_at_text" label="创建时间" align="center" />
        <el-table-column label="修改管理员" align="center">
          <template #default="{ row }">
            <el-button type="primary" @click="openAdminDialog(row)">修改</el-button>
          </template>
        </el-table-column>

      </el-table>

      <!-- 分页 -->
      <div class="pager">
        <el-pagination
          background
          layout="prev, pager, next, sizes, total"
          :page-sizes="[10,20,50,100]"
          :page-size="pageSize"
          :current-page="page"
          :total="total"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        />
      </div>
    </el-card>

    <!-- 弹窗：修改应用 ID -->
    <el-dialog
      title="修改应用 ID"
      :visible.sync="dialogVisible"
      width="400px"
      @close="resetDialog"
    >
      <div>
        <el-input
          v-model.number="dialogAgentId"
          placeholder="请输入新的应用 ID"
          @keyup.enter.native="confirmEdit"
        />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="resetDialog">取消</el-button>
        <el-button type="primary" @click="confirmEdit">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="修改管理员"
      :visible.sync="adminDialogVisible"
      width="400px"
      @close="resetAdminDialog"
    >
      <div>
        <el-select v-model="selectedAdminId" placeholder="请选择管理员" style="width: 100%;">
          <el-option
            v-for="item in adminList"
            :key="item.admin_id"
            :label="item.admin_name"
            :value="item.admin_id"
          />
        </el-select>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="resetAdminDialog">取消</el-button>
        <el-button type="primary" @click="confirmAdminEdit">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { corpList, updateList } from '@/api/h5App.js'
import { getadminlist } from '@/api/sourceMaterial.js'

export default {
  name: 'CorpListElement',
  data() {
    return {
      corpListData: [],
      page: 1,
      pageSize: 10,
      total: 0,
      searchText: '',
      loading: false,

      dialogVisible: false,
      dialogRow: null,
      dialogAgentId: null,
      adminDialogVisible: false,
      currentRow: null,
      selectedAdminId: null,
      adminList: []

    }
  },
  async created() {
    await this.fetchList()
  },
  methods: {
    // 拉取列表，带上 keywords，控制 loading
    async fetchList() {
      this.loading = true
      try {
        const res = await corpList({
          page: this.page,
          page_size: this.pageSize,
          keywords: this.searchText.trim()
        })
        this.corpListData = res.data.list.map(item => ({
          ...item,
          relaySourceBool: item.relay_source === '是' || item.relay_source === 1,
          _oldAgent: item.agent_id,
          _oldRelay: item.relay_source === '是' || item.relay_source === 1
        }))
        this.total = res.data.total
      } catch (err) {
        console.error('❌ 获取企业列表失败：', err)
      } finally {
        this.loading = false
      }
    },

    // 搜索：重置页码，调用接口
    onSearch() {
      this.page = 1
      this.fetchList()
    },

    // 分页：带上搜索关键词
    handleCurrentChange(newPage) {
      this.page = newPage
      this.fetchList()
    },
    handleSizeChange(newSize) {
      this.pageSize = newSize
      this.page = 1
      this.fetchList()
    },

    // 复制文字
    copyText(text) {
      navigator.clipboard.writeText(text)
        .then(() => this.$message.success('复制成功'))
        .catch(() => this.$message.error('复制失败'))
    },

    // 弹窗相关
    openDialog(row) {
      this.dialogRow = row
      this.dialogAgentId = row.agent_id
      this.dialogVisible = true
    },
    resetDialog() {
      this.dialogVisible = false
      this.dialogRow = null
      this.dialogAgentId = null
    },
    async confirmEdit() {
      if (!this.dialogRow) return
      if (this.dialogAgentId === this.dialogRow._oldAgent) {
        this.$message.info('未做修改')
        return this.resetDialog()
      }
      try {
        await updateList({
          corp_id: this.dialogRow.corp_id,
          agent_id: this.dialogAgentId
        })
        this.dialogRow.agent_id = this.dialogAgentId
        this.dialogRow._oldAgent = this.dialogAgentId
        this.$message.success('应用 ID 修改成功')
      } catch (err) {
        this.$message.error('应用 ID 修改失败')
      } finally {
        this.resetDialog()
      }
    },

    // 转发源开关切换
    async onRelayChange(row) {
      // 使用临时变量保存当前值
      const oldRelay = row._oldRelay
      const oldRelaySourceBool = row.relaySourceBool
      const val = row.relaySourceBool ? 1 : 2
      try {
        await updateList({
          corp_id: row.corp_id,
          relay_source: val
        })
        // 更新同步后的新值
        this.$set(row, '_oldRelay', oldRelaySourceBool)
        this.$message.success('是否开启转发源修改成功')
      } catch (err) {
        // 回滚
        this.$set(row, 'relaySourceBool', oldRelay)
        this.$message.error('是否开启转发源修改失败，已还原')
      }
    },

    // 打开管理员修改弹窗
    async openAdminDialog(row) {
      this.currentRow = row
      this.adminDialogVisible = true
      this.selectedAdminId = null

      try {
        const res = await getadminlist({ is_super: true })
        this.adminList = res.data.list
      } catch (err) {
        this.$message.error('获取管理员列表失败')
      }
    },

    // 重置管理员弹窗
    resetAdminDialog() {
      this.adminDialogVisible = false
      this.selectedAdminId = null
      this.currentRow = null
      this.adminList = []
    },

    // 确认修改管理员
    async confirmAdminEdit() {
      if (!this.selectedAdminId) {
        return this.$message.error('请选择管理员')
      }

      try {
        await updateList({
          corp_id: this.currentRow.corp_id,
          admin_id: this.selectedAdminId
        })

        this.$message.success('管理员修改成功')
        this.fetchList() // 刷新列表
      } catch (err) {
        this.$message.error('管理员修改失败')
      } finally {
        this.resetAdminDialog()
      }
    }
  }
}
</script>

<style scoped>
.boxes-card { padding: 20px; }
.box-card { width: 100%; margin: 20px auto; }
.search-bar { padding: 10px; }
.copy-text {
  cursor: pointer;
  color: #165DFF;
}
.loading-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 0;
  color: #909399;
}
.pager { margin: 16px 0; text-align: right; }
/* 对话框内 input 拉满 */
.el-dialog .el-input { width: 100%; }
</style>
